var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-nav',{staticClass:"navbar-top navbar-dark",attrs:{"id":"navbar-main","show-toggle-button":false,"expand":""}})}
var staticRenderFns = []

export { render, staticRenderFns }